import { blogServices } from "../../../services";
import { blogPosts } from "../../../assets/BlogPosts";

export const blogPostsLoader = async () => {
  try {
    const response = await blogServices.allPosts("?limit=20&page=1");
    if (!response)
      throw new Response("Failed to load blog posts", { status: 404 });
    return response;
  } catch (error) {
    throw new Response("Failed to load blog posts", { status: 500 });
  }
};

export async function blogPostLoader({ params }) {
  try {
    const { id } = params;
    if (!id) {
      throw new Response("Not Found", { status: 404 });
    }
    if (id === "1") {
      return blogPosts[0];
    }
    if (id === "2") {
      return blogPosts[1];
    }
    if (id === "3") {
      return blogPosts[2];
    }
    const response = await blogServices.getPost(id);
    if (!response)
      throw new Response("Failed to load blog posts", { status: 404 });
    return response;
  } catch (error) {
    throw new Response("Failed to load blog posts", { status: 500 });
  }
}
